var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_vm._m(0),_c('div',{staticClass:"col-sm-6"},_vm._l((_vm.options.points),function(point,i){return _c('win-point',{key:i,staticClass:"row winning-point",attrs:{"point":point}})}),1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-sm-6 winning-trophy-container"},[_c('img',{staticClass:"winning-trophy",attrs:{"src":require("@img/misc/trophy.png")}})])
}]

export { render, staticRenderFns }